import React from "react";
import InternalAccountsLabel from "./internal-accounts-label.component";
import StylizedRadioGroup from "../../../misc/stylized-radio-group.component";

const InternalSkipAccounts = (props) => {
  const accountsElementsArray = props.accounts.map((account) => {
    return {
      label: <InternalAccountsLabel {...account} />,
      value: account.AccountHash,
      id: account.AccountHash,
    };
  });

  if (!props.accounts || props.accounts.length === 0) {
    return <div>There are no eligible accounts at this time.</div>;
  }

  return (
    <div>
      <StylizedRadioGroup
        fieldGroupName="AccountHash"
        radioOptions={accountsElementsArray}
        thisForm={props.thisForm}
        change={props.change}
      />
    </div>
  );
};

export default InternalSkipAccounts;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/general/internal-skip-accounts.component.js